export const emailLink = {
  'Confirm your attendance at the sessions':
    'Confirme su asistencia a las sesiones',
};
